import { Transition } from "@headlessui/react";
import { ReactNode, useState } from "react";
import { useDebounce } from "use-debounce";
import { cn } from "cy-fe/src/utils/cn";

export function StepTransitionContainer({
  children,
  show,
  direction,
}: {
  children: ReactNode;
  show: boolean;
  direction: "left" | "right" | "none";
}) {
  const [transitioning, setTransitioning] = useState(false);
  // we need to debounce it because it needs time to update the direction on route
  // navigation
  const [debouncedShow] = useDebounce(show, 10);
  return (
    <div
      className={cn(
        "absolute right-0 left-0",
        transitioning && "overflow-hidden",
      )}
    >
      <Transition
        afterEnter={() => setTransitioning(false)}
        afterLeave={() => setTransitioning(false)}
        beforeEnter={() => setTransitioning(true)}
        beforeLeave={() => setTransitioning(true)}
        enter="transform transition-all  duration-500"
        enterFrom={cn(
          "opacity-0",
          direction === "left" && "translate-x-[30vw]",
          direction === "right" && "translate-x-[-30vw]",
        )}
        enterTo="opacity-100 translate-x-0"
        entered="overflow-auto"
        leave="transform transition-all duration-500"
        leaveFrom="opacity-100 scale-100 translate-x-0"
        leaveTo={cn(
          "opacity-0",
          direction === "left" && "translate-x-[-30vw]",
          direction === "right" && "translate-x-[30vw]",
        )}
        show={debouncedShow}
      >
        <div>{children}</div>
      </Transition>
    </div>
  );
}
